module.exports = __webpack_public_path__ + "static/media/wave-key.5febe98a.svg";